import { render, staticRenderFns } from "./verGrupo.vue?vue&type=template&id=e498d5e4&scoped=true&"
import script from "./verGrupo.vue?vue&type=script&lang=js&"
export * from "./verGrupo.vue?vue&type=script&lang=js&"
import style0 from "./verGrupo.vue?vue&type=style&index=0&id=e498d5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e498d5e4",
  null
  
)

export default component.exports